<template>
  <div>
    <el-input v-model="raddress" placeholder="请输入收货地址" style="margin-bottom: 10px;" />
    <el-table :data="contacts" border style="width: 100%; margin-bottom: 10px;">
      <el-table-column label="联系人" align="center">
        <template v-slot="scope">
          <el-input v-model="scope.row.name" placeholder="请输入联系人"/>
        </template>
      </el-table-column>

      <el-table-column label="手机" align="center">
        <template v-slot="scope">
          <el-input v-model="scope.row.phone" placeholder="请输入手机号"/>
        </template>
      </el-table-column>
      <el-table-column label="部门" align="center">
        <template v-slot="scope">
          <el-input v-model="scope.row.bumen" placeholder="请输入部门"/>
        </template>
      </el-table-column>

      <el-table-column label="邮箱" align="center">
        <template v-slot="scope">
          <el-input v-model="scope.row.email" placeholder="请输入邮箱"/>
        </template>
      </el-table-column>

      <el-table-column label="电话" align="center">
        <template v-slot="scope">
          <el-input v-model="scope.row.tel" placeholder="请输入电话"/>
        </template>
      </el-table-column>

      <el-table-column label="传真" align="center">
        <template v-slot="scope">
          <el-input v-model="scope.row.max" placeholder="请输入传真"/>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center">
        <template v-slot="scope">
          <el-button type="danger" size="small" @click="removeContact(scope.$index)" class="el-icon-delete">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-button type="primary" @click="addContact" size="small" class="el-icon-plus">添加联系人</el-button>
  </div>
</template>

<script>
import { defineComponent, ref, watch,onMounted } from '@vue/composition-api'

export default defineComponent({
  props: {
    data: {
      type: Array,
      default() {return []}
    },
    listrow: {
      type: Array,
      default() {return []}
    }
  },
  setup(props,{ emit }) {
    const raddress = ref('')
    const contacts = ref([
      { name: '', phone: '', bumen: '', email: '', tel: '',max:'' }
    ])

    // 添加联系人
    const addContact = () => {
      contacts.value.push({ name: '', phone: '', bumen: '', email: '', tel: '',max:''})
    }

    // 删除联系人
    const removeContact = (index) => {
      contacts.value.splice(index, 1)
    }
    // 定义一个清空数据的方法
    const clearTable = () => {
      contacts.value.forEach(row => {
        Object.keys(row).forEach(key => {
          row[key] = '' // 清空每一项的值
        })
      })
    }
    watch(()=>props.data,(val)=>{
      if(val) {
        contacts.value = val
      }
    })

    watch(()=>props.listrow,(val)=>{
      if(val.length>0) {
        raddress.value = val[0].raddress
      }
    },{immediate: true,deep:true})

    return {
      raddress,
      contacts,
      addContact,
      clearTable,
      removeContact
    }
  }
})
</script>
